module.exports = __webpack_public_path__ + "assets/img/capabilities_img3.1f9c589a.png";